module.exports = __webpack_public_path__ + "media/images/tumbleweed-3a39b105.svg";